import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 w-10 h-10 flex items-center justify-center rounded-full bg-background-900/80 border border-background-700/60 text-foreground-300 hover:text-primary-400 hover:border-primary-500/40 hover:bg-background-900 transition-all cursor-pointer backdrop-blur-sm"
      aria-label="回到顶部"
    >
      <span className="w-4 h-4 flex items-center justify-center">
        <i className="ri-arrow-up-line" />
      </span>
    </button>
  );
}